import Api from '../services/Api';

export async function publishBuilding(buildingId, currentState) {
  const response = await Api.patch(`/instances/buildings/${buildingId}`, {
    in_review: !currentState,
  });
  return response.data;
}

export async function publishComponent(componentId, currentState) {
  const response = await Api.patch(`/instances/building-components/${componentId}`, {
    in_review: currentState === 1 ? 0 : 1,
  });
  return response.data;
}

export async function publishElement(elementId, currentState) {
  const response = await Api.patch(`/instances/building-elements/${elementId}`, {
    in_review: currentState === 1 ? 0 : 1,
  });
  return response.data;
}

export async function publishContext(elementId, currentState) {
  const response = await Api.patch(`/instances/building-contexts/${elementId}`, {
    in_review: currentState === 1 ? 0 : 1,
  });
  return response.data;
}

export async function publishProduct(elementId, currentState) {
  const response = await Api.patch(`/instances/building-products/${elementId}`, {
    in_review: currentState === 1 ? 0 : 1,
  });
  return response.data;
}

export async function publishCharacteristic(elementId, currentState) {
  const response = await Api.patch(`/instances/building-characteristics/${elementId}`, {
    in_review: currentState === 1 ? 0 : 1,
  });
  return response.data;
}
